import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import { DeactivateGuard } from '../../shared/guards/candeactivate';
import {ServiceScheduleComponent} from './service-schedule.component';


const routes: Routes = [
  {
    path: '',
    component: ServiceScheduleComponent,
    canDeactivate:[DeactivateGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ServiceScheduleRoutingModule {
}
